import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom as _fvf } from 'rxjs';
import { IService } from '../../../../core/interfaces/i.service.interface';
import { IResponse } from '../../../../core/interfaces/response.interface';
@Injectable({ providedIn: 'root' })
export class ContactUsService implements IService {
  _baseUrl: string = 'contact-us';
  constructor(private httpClient: HttpClient) {}

  sendMessage(messageInfo: any) {
    return _fvf(
      this.httpClient.post<IResponse<any>>(`${this._baseUrl}`, messageInfo),
    );
  }
}
